import { addReaction, renderReactionCount } from '../reactions'

const ROOT_SELECTOR = '[data-review-helpful]'
const STORAGE_PREFIX = 'hapisumu_review_helpful:'
const pending = new Set()

function reviewIdFromRoot(root) {
  const value = root.dataset.reviewId
  const number = Number(value)
  return /^\d+$/.test(value || '') && Number.isSafeInteger(number) && number > 0 ? number : null
}

function readState(reviewId) {
  const value = localStorage.getItem(`${STORAGE_PREFIX}${reviewId}`)
  if (value === null) return null
  const state = JSON.parse(value)
  if (typeof state?.pressed !== 'boolean'
    || !Number.isSafeInteger(state.count) || state.count < 0) throw new Error('Invalid helpful state')
  return state
}

function writeState(reviewId, state) {
  localStorage.setItem(`${STORAGE_PREFIX}${reviewId}`, JSON.stringify(state))
}

function setStatus(root, message, isError = false) {
  const status = root.querySelector('[data-review-helpful-status]')
  if (!status) return
  status.textContent = message
  status.classList.toggle('sr-only', !isError)
}

function renderRoot(root) {
  const button = root.querySelector('[data-review-helpful-toggle]')
  const countElement = root.querySelector('[data-review-helpful-count]')
  if (!button || !countElement) return
  const reviewId = reviewIdFromRoot(root)
  button.disabled = true
  if (reviewId === null) {
    button.setAttribute('aria-pressed', 'false')
    button.setAttribute('aria-label', 'この口コミでは「参考になった」を利用できません')
    return
  }
  try {
    const state = readState(reviewId)
    const count = Math.max(Number(countElement.textContent), state?.count || 0)
    const pressed = state?.pressed === true
    renderReactionCount(countElement, count)
    button.disabled = pressed || pending.has(reviewId)
    button.setAttribute('aria-pressed', String(pressed))
    button.setAttribute('aria-label', 'この口コミが参考になった')
  } catch (_error) {
    setStatus(root, '参考になった機能を利用できません。ブラウザのデータ保存設定をご確認ください。', true)
  }
}

function renderAll(root = document) {
  if (root.matches?.(ROOT_SELECTOR)) renderRoot(root)
  root.querySelectorAll(ROOT_SELECTOR).forEach(renderRoot)
}

function renderReview(reviewId) {
  document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
    if (reviewIdFromRoot(root) === reviewId) renderRoot(root)
  })
}

async function handleClick(event) {
  if (!(event.target instanceof Element)) return
  const button = event.target.closest('[data-review-helpful-toggle]')
  const root = button?.closest(ROOT_SELECTOR)
  if (!(button instanceof HTMLButtonElement) || !(root instanceof HTMLElement)) return
  const reviewId = reviewIdFromRoot(root)
  if (reviewId === null || button.disabled || pending.has(reviewId)) return
  pending.add(reviewId)
  setStatus(root, '')
  try {
    const state = readState(reviewId)
    if (state?.pressed) return
    // 保存できないブラウザでは送信しない。
    writeState(reviewId, { pressed: false, count: 0 })
    renderReview(reviewId)
    const count = await addReaction('reform_review_helpful_added', { review_id: reviewId })
    writeState(reviewId, { pressed: true, count })
    setStatus(root, `「参考になった」として受け付けました。現在${count}件です。`)
  } catch (_error) {
    setStatus(root, '保存を確認できませんでした。通信とブラウザのデータ保存設定をご確認のうえ、もう一度お試しください。', true)
  } finally {
    pending.delete(reviewId)
    renderReview(reviewId)
  }
}

export { renderAll as initReviewHelpfulButtons }

document.addEventListener('click', handleClick)
document.addEventListener('htmx:afterSwap', (event) => renderAll(event.target))
window.addEventListener('storage', (event) => {
  if (event.key === null) {
    renderAll()
  } else if (event.key.startsWith(STORAGE_PREFIX)) {
    renderReview(Number(event.key.slice(STORAGE_PREFIX.length)))
  }
})
